export default __webpack_public_path__ + "static/media/valorant.994bd8ad.jpg";